import styled from "@emotion/styled";
import { Box, CircularProgress } from "@material-ui/core";
import React from "react";

const Container = styled(Box)`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
`

const LoadingBlock = () => {
  return (
    <Container>
      <CircularProgress color="secondary" />
    </Container>
  )
}

export default LoadingBlock
